export default class GeoApi
{
    constructor(dashApi) {
        this.DashAPI = dashApi;
        this.DashAPI.ApiPathMgr.add(GeoApi.RegionsPath);
        this.DashAPI.ApiPathMgr.add(GeoApi.CitiesPath);
        this.DashAPI.ApiPathMgr.add(GeoApi.NeighborhoodsPath);
    }

    getRegions() {
        return this.DashAPI.CORE.get(GeoApi.RegionsPath);
    }

    getCitiesByRegionId(regionId) {
        return this.DashAPI.CORE.get(GeoApi.RegionsPath + '/' + regionId + '/cities');
    }

    getCityById(cityId) {
        return this.DashAPI.CORE.get(GeoApi.CitiesPath + '/' + cityId)
    }

    getNeighborhoods() {
        return this.DashAPI.CORE.get(GeoApi.NeighborhoodsPath);
    }

    getNeighborhoodById(neighborhoodId) {
        return this.DashAPI.CORE.get(GeoApi.NeighborhoodsPath + '/' + neighborhoodId);
    }

    getRegionById(regionId) {
        return this.DashAPI.CORE.get(GeoApi.RegionsPath + '/' + regionId);
    }
}

GeoApi.CitiesPath = '/api/geo/cities';
GeoApi.NeighborhoodsPath = '/api/geo/neighborhoods';
GeoApi.RegionsPath = '/api/geo/regions';



// WEBPACK FOOTER //
// ./src/DashApi/geo/GeoApi.js


// WEBPACK FOOTER //
// webpack:///src/DashApi/geo/GeoApi.js